import { render, staticRenderFns } from "./ExtractTransactions.vue?vue&type=template&id=6dcfc5c8&"
import script from "./ExtractTransactions.vue?vue&type=script&lang=js&"
export * from "./ExtractTransactions.vue?vue&type=script&lang=js&"
import style0 from "./ExtractTransactions.vue?vue&type=style&index=0&id=6dcfc5c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports